import React, { useEffect, useState } from "react";
import validator from "@rjsf/validator-ajv8";
import Form from "@rjsf/mui";
import { db } from "../../indexDB/model";
import { useLocation } from "react-router-dom";
import FileFactory from "../customComponents/fileWidget/FileFactory";
import { Container } from "@mui/material";
import Datapoint from "./datapointV2";
import { isObject } from "@rjsf/utils";

/**
 * Component for viewing datapoint details.
 *
 * @component
 * @example
 * // Example usage of ViewDatapoint component
 * <ViewDatapoint />
 *
 * @returns {JSX.Element} - ViewDatapoint component.
 */
const ResumeDatapoint = ({handleLogout}) => {
  const { state } = useLocation();
  const [schema, setSchema] = useState(null);
  const [dataset, setDataset] = useState(null);

  const draftId =  state.draftId
  const draftDatetime = state.draftDatetime
  const formData = state.formData
  const fileData = state.fileData
  const datasetId = state.datasetId
  const collapsibleSections = state.collapsibleSections

  const formatFileData = (fileData) =>{
    const items =  []
    const keys = Object.keys(fileData)
    keys.forEach(key => {
      const arr = fileData[key]
      if (!Array.isArray(arr)){
        return
      }
      arr.forEach(item =>{
        const file =  item.file
        const metadata =  item.metadata
        const label = key
        if (item.file) {
          items.push({
            label:label,
            metadata: metadata,
            data: file
          })
        }
      });
      
    });
    return items
  }



  /**
   * Fetches the schema for a given dataset ID and updates the state.
   *
   * @param {string} datasetID - ID of the dataset.
   * @returns {void}
   */
  async function getSchema(datasetId) {
    try {
      const dataset = await db.datasets
        .where("uuid")
        .equals(datasetId)
        .toArray();
      const project = await db.projects.where("uuid").equals(dataset[0].projectID).toArray()
      localStorage.setItem('dataset_id',dataset[0].id)
      localStorage.setItem('project_id',dataset[0].projectID)
      localStorage.setItem('project',project[0].name)
      setDataset(dataset[0])
      setSchema(dataset[0]?.schema);
    } catch (error) {
      console.error("Error fetching schema:", error);
    }
  }

  useEffect(() => {
    if (datasetId) {
      getSchema(datasetId);
    }
  }, [datasetId]);

  /**
   * Custom widget for FileWidget in the form.
   *
   * @param {Object} props - Widget props.
   * @returns {JSX.Element} - FileFactoryOfflinePreview widget.
   */


  return (
    <>
    {
      dataset ? <Datapoint dataset={dataset} handleLogout={handleLogout} fileData={formatFileData(fileData)} prevFormData={formData} draftId={draftId} draft={true} collapsibleSections={collapsibleSections} draftDatetime={draftDatetime}/> : <div>Loading</div>
    }
    </>
  );
};

export default ResumeDatapoint;